import React from "react";
import FormInput from "./FormInput";
import { Container } from "../../pages/ScenarioCreation/components/SegmentSelection/DynamicContents.Styled";
import PackSegments from "./PackSegments";
import StateSelection from "./StateSelection";

const FormComponent: React.FC<{ data: any; selectedTab: any }> = ({
  data,
  selectedTab,
}) => {
  return (
    <Container>
      <StateSelection />
      <PackSegments data={data} />
      <FormInput selectedTab={selectedTab} />
    </Container>
  );
};

export default FormComponent;
